import { render, staticRenderFns } from "./RouteMakingTrips.vue?vue&type=template&id=7b378a42&scoped=true&"
import script from "./RouteMakingTrips.vue?vue&type=script&lang=js&"
export * from "./RouteMakingTrips.vue?vue&type=script&lang=js&"
import style0 from "./RouteMakingTrips.vue?vue&type=style&index=0&id=7b378a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b378a42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VPagination,VSkeletonLoader,VTextField})
